import { reverse, sortBy, toNumber } from 'lodash-es'
import { storeyToLabel } from '@editor/pages/Plans/components/AddPlanDialog/components/utils'

export const NO_UPPER_STOREY = ''

const formatMetres = (value: number): string =>
  `${new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)} m`

const orderedStoreys = (storeyBoundaries: StoreyBoundaries): string[] =>
  reverse(sortBy(Object.keys(storeyBoundaries), storey => toNumber(storey)))

export const defaultUpperStorey = (
  storeyBoundaries: StoreyBoundaries,
  wallStorey: string,
): string => (storeyBoundaries[wallStorey] ? wallStorey : NO_UPPER_STOREY)

export const defaultLowerStorey = (
  storeyBoundaries: StoreyBoundaries,
  wallStorey: string,
): string => {
  if (storeyBoundaries[wallStorey]) return wallStorey
  const ordered = orderedStoreys(storeyBoundaries)
  return ordered[ordered.length - 1] ?? wallStorey
}

export const buildLowerStoreyOptions = (storeyBoundaries: StoreyBoundaries) =>
  orderedStoreys(storeyBoundaries).map(storey => ({
    value: storey,
    label: `${storeyToLabel(storey)} (Unterkante ${formatMetres(storeyBoundaries[storey][0])})`,
  }))

export const buildUpperStoreyOptions = (storeyBoundaries: StoreyBoundaries) => [
  { value: NO_UPPER_STOREY, label: 'keine' },
  ...orderedStoreys(storeyBoundaries).map(storey => ({
    value: storey,
    label: `${storeyToLabel(storey)} (Oberkante ${formatMetres(storeyBoundaries[storey][1])})`,
  })),
]

export const canSubmitConfiguredWallCut = (upperStorey: string, roofSlabCount: number): boolean =>
  upperStorey !== NO_UPPER_STOREY || roofSlabCount > 0
